<!-- eslint-disable vue/no-v-html -->
<template>
  <form class="visitor-step-2 visitor-step-2-theme">
    <div class="visitor-step-2-inner">
      <div class="visitor-step-2-img-wrapper">
        <img
          class="visitor-step-2-img"
          :src="visitorImage"
          alt="paper-plane-image"
        >
      </div>
      <p
        class="visitor-step-2-desc check-the-email"
        v-html="$t('visitorCheckTheEmail')"
      />
    </div>
  </form>
</template>

<script>
import { isIE } from '../../../api/utils'
import paperPlaneImage from './img/visitor-step2-ie.svg'
import paperPlaneWithAnimateImage from './img/visitor-step2.svg'

export default {
  name: 'VisitorStep2',

  props: {
  },

  data () {
    return {
    }
  },

  computed: {
    visitorImage () {
      if (isIE()) {
        return paperPlaneImage
      }

      return paperPlaneWithAnimateImage
    }
  },

  methods: {
  }
}
</script>

<style lang="stylus" rel="stylesheet/stylus" scoped>
@import '~css/addon/main';

.visitor-step-2 {
  $mb = 18px;
  position: relative;
  height: "calc(100% - %s)" % $mb;
  padding-top: 10px;
  margin-bottom: $mb;

  $mb-l = 25px;
  @media (min-width: $layout) {
    padding-top: 14px;
    height: "calc(100% - %s)" % $mb-l;
    margin-bottom: $mb-l;
  }

  $mb-l = 41px;
  @media (min-width: $response) {
    height: "calc(100% - %s)" % $mb-l;
    padding-top: 36px;
    margin-bottom: $mb-l;
  }
}

$inner-padding = 32px;
$inner-padding-l = 80px;
.visitor-step-2-inner {
  height: calc(100% - 45px);
  padding-left: $inner-padding;
  padding-right: $inner-padding;
  padding-bottom: $inner-padding;
  overflow-y: auto;
  overflow-x: hidden;
  -webkit-overflow-scrolling: touch;

  @media (min-width: $response) {
    padding-left: $inner-padding-l;
    padding-right: $inner-padding-l;
  }
}

.visitor-step-2-theme {
  p, a {
    color: $visitor-text-color;
    text-shadow: none;
  }

  a {
    &:hover {
      cursor: pointer;
      color: #5d5d5d;
    }
  }
}

.visitor-step-2-img-wrapper {
  margin-top: 54px;
  margin-bottom: 14px;
  text-align: center;

  @media (min-width: $layout) {
    margin-top: 75px;
    margin-bottom: 13px;
  }

  @media (min-width: $response) {
    margin-top: 71px;
    margin-bottom: 21px;
  }
}

.visitor-step-2-img {
  width: 50px;
  height: 42px;

  @media (min-width: $layout) {
    width: 62px;
    height: 52px;
  }

  @media (min-width: $response) {
    width: 60px;
    height: 60px;
  }
}

.visitor-step-2-desc {
  height: 48px;
  margin-bottom: 35px;
  font-size: 0.8125rem;
  letter-spacing: 0.9px;
  line-height: 1.38;
  overflow: auto;

  &.check-the-email {
    margin-top: 50px;
    margin-bottom: 0;
    height: auto;
  }

  @media (min-width: $layout) {
    font-size: 1rem;
    line-height: 1.25;
    letter-spacing: 1.1px;
  }

  @media (min-width: $response) {
    font-size: 0.875rem;
    height: 100px;
    margin-bottom: 7px;
    letter-spacing: 0.23px;
    line-height: 1.5;
  }
}

</style>
